<template>
  <v-container class="py-10" id="informationsbedarf">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#005a85">Herausforderungen</div>
        <h2>Informationsbedarf</h2>
        <p>
          Obwohl die Digitalsierung insgesamt als Herausforderung gesehen wird,
          geben die meisten Organisationen an, keinen konkreten
          Informationsbedarf zu haben. Am meisten Informationsbedarf sehen sie
          bei der Nutzung sozialer Medien (<b>37%</b>), Auswahl von
          Software-Produkten (<b>37%</b>) und vor allem bei Datenschutz und
          IT-Sicherheit (<b>52%</b>).
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'Informationsbedarf' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Beratungsbedarf",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Informationsbedarf"
        },
        xAxis: {
          categories: [
            "Datenschutz und IT-Sicherheit",
            "Auswahl von Softwareprodukten",
            "Nutzung sozialer Medien",
            "Formen virtueller Zusammenarbeit",
            "Cloud-Angebote",
            "Anwendung neuer Technologien",
            "Auswahl von Hardwareprodukten",
            "Organisation der IT-Betreuung",
            "keinen Informationsbedarf"
          ],
          crosshair: false
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0,
            borderWidth: 0
          }
        },
        //colors: ["#9d0c4a", "#ad4594", "#e353aa"],
        series: [
          {
            name: "Ja",
            data: [
              52.41807,
              36.85052,
              36.67066,
              32.05436,
              31.03517,
              29.43645,
              25.01998,
              25.03997,
              15.08793
            ]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Informationsbedarf",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
